import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import $ from 'jquery';

function Otpcheck() {

    const history = useHistory();

    const [resendBtn, setResendBtn] = useState(true);


    const Clock = () => {
        const [currentCount, setCount] = useState(5);
        const timer = () => setCount(currentCount - 1);

        useEffect(
            () => {
                if (currentCount <= 0) {
                    return;
                }
                const id = setInterval(timer, 1000);
                return () => clearInterval(id);
            },
            [currentCount]
        );

        if (currentCount >= 0) {

            setResendBtn(false);
            return <div>(00:{currentCount})</div>;

        }
        if (currentCount == 0) {
            setResendBtn(true);
            return <span></span>;
        }

    };


    $('.digit-group').find('input').each(function () {
        $(this).attr('maxlength', 1);
        $(this).on('keyup', function (e) {
            var parent = $($(this).parent());

            if (e.keyCode === 8 || e.keyCode === 37) {
                var prev = parent.find('input#' + $(this).data('previous'));

                if (prev.length) {
                    $(prev).select();
                }
            } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                var next = parent.find('input#' + $(this).data('next'));

                if (next.length) {
                    $(next).select();
                } else {
                    if (parent.data('autosubmit')) {
                        parent.submit();
                    }
                }
            }
        });
    });

    const [otpInfo, setOtPInfo] = useState({
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
    });

    const [errors, setErrors] = useState({});
    const [disable, setDisable] = useState(false);

    const InputEvent = (e) => {
        const newOTPInfo = { ...otpInfo };
        if (e.target.value.length === 2) {
            e.target.value = e.target.value.slice(0, 1);
        }
        newOTPInfo[e.target.name] = e.target.value;
        setOtPInfo(newOTPInfo);
    }

    const submitHandler = (e) => {
        e.preventDefault();
        if (validate()) {
            setDisable(true);
            const { email, password } = otpInfo;

            const myurl = "https://events.teambuildingawards.com:3000/api/web/check-otp";
            var bodyFormData = new URLSearchParams();
            bodyFormData.append('email', localStorage.getItem("TBA_CLIENT_EMAIL"));
            bodyFormData.append('otp', otpInfo.one + otpInfo.two + otpInfo.three + otpInfo.four + otpInfo.five);
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            }).then((response) => {
                console.log(response);
                if (response.data.success == true) {
                    localStorage.setItem('TBA_CLIENT_ID', response.data.data.host_id);
                    // toast.success("Login Successfully...!");
                    $(".tba-modal-close-btn").click();
                    setDisable(false);
                    history.push(`/`);
                    setTimeout(function () {
                        window.scrollTo({ behavior: 'smooth', top: 0 })
                    }, 1500);
                } else {
                    setDisable(false);
                    toast.error(response.data.message);
                }

            }).catch((error) => {
                console.log("Errors", error);
            })


        }
    }

    const validate = () => {
        let input = otpInfo;

        let errors = {};
        let isValid = true;

        if (!input["one"] && !input["two"] && !input["three"] && !input["four"] && !input["five"]) {
            isValid = false;
            errors["otp_err"] = "Please enter OTP";
        }


        setErrors(errors);
        return isValid;
    }

    const callResend = (e) => {

        const myurl = "https://events.teambuildingawards.com:3000/api/web/resend-otp";
        var bodyFormData = new URLSearchParams();
        bodyFormData.append('email', localStorage.getItem("TBA_CLIENT_EMAIL"));
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((response) => {
            //console.log("AF",response?.data?.data);
            toast.success("OTP Resend Successfully...!Please check your Mail");
            //Clock();
        }).catch((error) => {
            console.log("Errors", error);
            setDisable(false);
        })

    }


    const pasteOTP = () => {
        navigator.clipboard.readText().then((copiedText) => {
            const newOTPInfo = {
                one: copiedText[0] || '',
                two: copiedText[1] || '',
                three: copiedText[2] || '',
                four: copiedText[3] || '',
                five: copiedText[4] || '',
            };
            setOtPInfo(newOTPInfo);
        }, () => {
            toast.error("Failed to read clipboard!");
        });
    }
    return (
        <>

            <span class="show-tbaOTPModal" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#tbaOTPModal"></span>

            <div className="modal fade" id="tbaOTPModal" tabindex="-1" aria-labelledby="tbaOTPModalLabel" aria-hidden="true" style={{ pointerEvents: 'none' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span data-bs-dismiss="modal" aria-label="Close" className="tba-modal-close-btn">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M25.4279 6.57187C22.9096 4.05353 19.5612 2.66666 15.9998 2.66666C12.4384 2.66666 9.0901 4.05353 6.57176 6.57192C4.05343 9.09025 2.6665 12.4385 2.6665 16C2.6665 19.5615 4.05338 22.9098 6.57171 25.4282C9.09005 27.9464 12.4383 29.3333 15.9998 29.3333C19.5612 29.3333 22.9096 27.9464 25.4279 25.4281C27.9462 22.9097 29.3332 19.5614 29.3332 16C29.3332 12.4385 27.9462 9.09025 25.4279 6.57187ZM24.3231 24.3233C22.0998 26.5464 19.1439 27.7708 15.9998 27.7708C12.8557 27.7708 9.89973 26.5464 7.67656 24.3233C5.45333 22.1 4.229 19.1442 4.229 16C4.229 12.8559 5.45343 9.89999 7.67661 7.67676C9.89984 5.45353 12.8557 4.22916 15.9998 4.22916C19.144 4.22916 22.0998 5.45353 24.3231 7.67671C28.9124 12.2662 28.9124 19.7338 24.3231 24.3233Z"
                                        fill="#FFFFFB" />
                                    <path
                                        d="M21.8775 20.773L17.1046 16L21.8775 11.2271C22.1826 10.922 22.1826 10.4273 21.8775 10.1223C21.5724 9.81718 21.0777 9.81718 20.7726 10.1223L15.9997 14.8952L11.2267 10.1222C10.9217 9.81713 10.427 9.81713 10.1219 10.1222C9.81679 10.4273 9.81679 10.922 10.1219 11.2271L14.8949 16L10.1219 20.773C9.81679 21.0781 9.81679 21.5728 10.1219 21.8779C10.2744 22.0304 10.4744 22.1067 10.6743 22.1067C10.8742 22.1067 11.0742 22.0304 11.2267 21.8779L15.9997 17.1049L20.7727 21.8779C20.9252 22.0304 21.1252 22.1067 21.3251 22.1067C21.5251 22.1067 21.725 22.0304 21.8775 21.8779C22.1826 21.5728 22.1826 21.0781 21.8775 20.773Z"
                                        fill="#FFFFFB" />
                                </svg>
                            </span>
                        </div>
                        <div className="modal-body">
                            <div className="tba-modal-content">
                                <div className="tba-modal-heading">
                                    <h2 className="tba-modal-title">OTP Verification</h2>
                                    <p className="tba-modal-description">We have sent the code verification to your email
                                    </p>
                                </div>
                                <form onSubmit={(e) => submitHandler(e)} >
                                    <div className="tba-login-content">
                                        <div className="tba-login-form tba-otp-form">
                                            {/* <p className="tba-otp-mobile-number">
                                    <span className="tba-otp-mobile-number-text">{localStorage.getItem("TBA_CLIENT_PHONE_NUMBER")}</span>
                                    <span className="tba-otp-mobile-edit" data-bs-dismiss="modal" aria-label="Close"
                                        data-bs-toggle="modal" data-bs-target="#tbaRegisterModal">
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M9.743 19H21.5V21H3.5V16.757L13.4 6.85702L17.642 11.101L9.742 19H9.743ZM14.813 5.44402L16.935 3.32202C17.1225 3.13455 17.3768 3.02924 17.642 3.02924C17.9072 3.02924 18.1615 3.13455 18.349 3.32202L21.178 6.15102C21.3655 6.33855 21.4708 6.59286 21.4708 6.85802C21.4708 7.12319 21.3655 7.37749 21.178 7.56502L19.056 9.68602L14.814 5.44402H14.813Z"
                                                fill="#F0C454" />
                                        </svg>
                                    </span>
                                </p> */}
                                            <div className="tba-otp-form__inner digit-group">
                                                <input type="number" name="one" minLength={1} maxLength={1} oninput="this.value=this.value.replace(/[^0-9]/g,'');" className="form-control" placeholder="*" onChange={InputEvent} value={otpInfo.one} id="digit-1" data-next="digit-2" />
                                                <input type="number" name="two" minLength={1} maxLength={1} oninput="this.value=this.value.replace(/[^0-9]/g,'');" className="form-control" placeholder="*" onChange={InputEvent} value={otpInfo.two} id="digit-2" data-next="digit-3" data-previous="digit-1" />
                                                <input type="number" name="three" minLength={1} maxLength={1} oninput="this.value=this.value.replace(/[^0-9]/g,'');" className="form-control" placeholder="*" onChange={InputEvent} value={otpInfo.three} id="digit-3" data-next="digit-4" data-previous="digit-2" />
                                                <input type="number" name="four" minLength={1} maxLength={1} oninput="this.value=this.value.replace(/[^0-9]/g,'');" className="form-control" placeholder="*" onChange={InputEvent} value={otpInfo.four} id="digit-4" data-next="digit-5" data-previous="digit-3" />
                                                <input type="number" name="five" minLength={1} maxLength={1} oninput="this.value=this.value.replace(/[^0-9]/g,'');" className="form-control" placeholder="*" onChange={InputEvent} value={otpInfo.five} id="digit-5" data-previous="digit-4" />
                                                <div className="text-danger">{errors.otp_err}</div>
                                            </div>
                                            {/* <span className="tba-otp-timner"><Clock /></span> */}
                                        </div>
                                        <button type="submit" className="btn btn-primary" disabled={disable}>{disable ? 'Processing...' : 'Check OTP'}</button>

                                        {resendBtn ?
                                            <p className="tba-modal-notes">Didn’t receive the otp? <a href="javascript:void(0);" onClick={callResend} >Resend
                                                OTP</a></p>
                                            : ''}
                                    </div>
                                </form>
                                <div className='text-center'> <button className="btn btn-primary mx-2 mt-2" onClick={pasteOTP}>Paste OTP</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Otpcheck
